// DEV-ONLY: mockups of the final score card, each one sitting in the same list style as an upcoming game.
// Open http://localhost:3000/?finalMock  (never active in a production build)
import React from 'react';

const logo = (a) => `https://assets.nhle.com/logos/nhl/svg/${a}_light.svg`;
const Logo = ({ a, size = 44 }) => <img src={logo(a)} alt="" style={{ width: size, height: size, objectFit: 'contain' }} />;
const NJD = '#CE1126';
const VGK = '#B4975A';

function Upcoming() {
  return (
    <div className="fm-card">
      <div className="fm-head"><Logo a="CHI" /><b className="fm-when">Sat, Oct 31, 1:00 p.m.</b><Logo a="BOS" /></div>
      <div className="fm-slots"><div className="fm-slot"><small>CHI</small><b>2.83</b></div><div className="fm-slot"><small>BOS</small><b>1.43</b></div></div>
    </div>
  );
}

// A: same card as an upcoming game, the scores go where the odds were
function Slots() {
  return (
    <div className="fm-card">
      <div className="fm-head"><Logo a="NJD" /><b className="fm-when">Final · Tonight</b><Logo a="VGK" /></div>
      <div className="fm-slots"><div className="fm-slot"><small>NJD</small><b className="big muted">2</b></div><div className="fm-slot win"><small>VGK</small><b className="big">4</b></div></div>
    </div>
  );
}

// B: same, and the winner's slot takes the team's colour
function SlotsColor() {
  return (
    <div className="fm-card">
      <div className="fm-head"><Logo a="NJD" /><b className="fm-when">Final · Tonight</b><Logo a="VGK" /></div>
      <div className="fm-slots"><div className="fm-slot"><small>NJD</small><b className="big muted">2</b></div><div className="fm-slot" style={{ background: VGK, borderColor: VGK, color: '#fff' }}><small style={{ color: '#fff' }}>VGK · WIN</small><b className="big">4</b></div></div>
    </div>
  );
}

// C: two lines like a box score, each with its team's colour
function Lines() {
  return (
    <div className="fm-card fm-lines">
      <div className="fm-line lose" style={{ '--c': NJD }}><Logo a="NJD" size={34} /><b>New Jersey</b><strong>2</strong></div>
      <div className="fm-line" style={{ '--c': VGK }}><Logo a="VGK" size={34} /><b>Vegas</b><strong>4</strong></div>
      <small className="fm-foot">Final · Tonight</small>
    </div>
  );
}

// D: the score by period
function Periods() {
  const rows = [['NJD', 1, 1, 0, 2], ['VGK', 2, 0, 2, 4]];
  return (
    <div className="fm-card fm-table">
      <div className="fm-tr fm-th"><span>Final</span><i>1</i><i>2</i><i>3</i><i>T</i></div>
      {rows.map(([a, p1, p2, p3, t]) => (
        <div key={a} className={`fm-tr${t === 2 ? ' lose' : ''}`}><span><Logo a={a} size={30} /><b>{a}</b></span><i>{p1}</i><i>{p2}</i><i>{p3}</i><strong>{t}</strong></div>
      ))}
    </div>
  );
}

// E: who did it: the score, and the game's best players under it
function Stars() {
  return (
    <div className="fm-card">
      <div className="fm-head"><Logo a="NJD" /><div className="fm-score"><span className="muted">2</span><small>FINAL</small><span>4</span></div><Logo a="VGK" /></div>
      <div className="fm-stars"><span><b>Eichel</b> 2G 1A</span><span><b>Stone</b> 1G 2A</span><span><b>Hughes</b> 1G</span></div>
    </div>
  );
}

// F: what it meant for you: the score, and how your bet went
function MyBet() {
  return (
    <div className="fm-card">
      <div className="fm-head"><Logo a="NJD" /><div className="fm-score"><span className="muted">2</span><small>FINAL</small><span>4</span></div><Logo a="VGK" /></div>
      <div className="fm-mybet"><span>Vegas to win · $40.00 @ 2.40</span><b>+$56.00</b></div>
    </div>
  );
}

// G: D and E together: the score by period, and the game's best players under it
function PeriodsStars() {
  const rows = [['NJD', 1, 1, 0, 2], ['VGK', 2, 0, 2, 4]];
  return (
    <div className="fm-card fm-table">
      <div className="fm-tr fm-th"><span>Final</span><i>1</i><i>2</i><i>3</i><i>T</i></div>
      {rows.map(([a, p1, p2, p3, t]) => (
        <div key={a} className={`fm-tr${t === 2 ? ' lose' : ''}`}><span><Logo a={a} size={30} /><b>{a}</b></span><i>{p1}</i><i>{p2}</i><i>{p3}</i><strong>{t}</strong></div>
      ))}
      <div className="fm-stars fm-stars-under"><span><b>Eichel</b> 2G 1A</span><span><b>Stone</b> 1G 2A</span><span><b>Hughes</b> 1G</span></div>
    </div>
  );
}

// the live card: G's table filling in as the game goes, the period being played in red, periods to come as a dash
const espn = (lg, a) => `https://a.espncdn.com/i/teamlogos/${lg}/500/${a}.png`;
function LiveTable({ cols, now, clock, teams, extra, players }) {
  const cells = `1fr repeat(${cols.length}, minmax(0, ${cols.length > 4 ? 30 : 44}px)) 56px`;
  return (
    <div className="fm-card fm-table fm-live">
      <div className="fm-now">
        <span className="fm-now-team"><img src={teams[0].logo} alt="" />{extra && <small>{extra}: {teams[0].extra}</small>}</span>
        <div className="fm-now-score">
          <strong className={teams[0].behind ? 'muted' : ''}>{teams[0].lines.slice(0, now + 1).reduce((a, b) => a + b, 0)}</strong>
          <span className="fm-now-clock"><u />{clock.split(' · ').map((x) => <b key={x}>{x}</b>)}</span>
          <strong className={teams[1].behind ? 'muted' : ''}>{teams[1].lines.slice(0, now + 1).reduce((a, b) => a + b, 0)}</strong>
        </div>
        <span className="fm-now-team home">{extra && <small>{extra}: {teams[1].extra}</small>}<img src={teams[1].logo} alt="" /></span>
      </div>
      <div className="fm-tr fm-th" style={{ gridTemplateColumns: cells }}>
        <span />
        {cols.map((c, i) => <i key={c} className={i === now ? 'now' : ''}>{c}</i>)}
        <i>T</i>
      </div>
      {teams.map((t) => (
        <div key={t.name} className={`fm-tr${t.behind ? ' lose' : ''}`} style={{ gridTemplateColumns: cells }}>
          <span><img src={t.logo} alt="" style={{ width: 30, height: 30, objectFit: 'contain' }} /><b>{t.name}</b></span>
          {cols.map((c, i) => <i key={c} className={i === now ? 'now' : ''}>{i > now ? '–' : t.lines[i]}</i>)}
          <strong>{t.lines.slice(0, now + 1).reduce((a, b) => a + b, 0)}</strong>
        </div>
      ))}
      <div className="fm-stars fm-stars-under">{players.map(([n, s]) => <span key={n}><b>{n}</b> {s}</span>)}</div>
    </div>
  );
}
const LiveNHL = () => <LiveTable cols={['1', '2', '3']} now={1} clock="2nd · 08:38" extra="SOG" players={[['Stone', '1G 1A'], ['Hughes', '1G'], ['Eichel', '1A']]} teams={[
  { name: 'NJD', logo: logo('NJD'), lines: [1, 0, 0], extra: 14, behind: true },
  { name: 'VGK', logo: logo('VGK'), lines: [1, 1, 0], extra: 17 },
]} />;
const LiveNBA = () => <LiveTable cols={['1', '2', '3', '4']} now={2} clock="3rd · 04:12" players={[['James', '24 pts'], ['Curry', '27 pts']]} teams={[
  { name: 'LAL', logo: espn('nba', 'lal'), lines: [28, 31, 19, 0] },
  { name: 'GSW', logo: espn('nba', 'gs'), lines: [25, 27, 22, 0], behind: true },
]} />;
const LiveMLB = () => <LiveTable cols={['1', '2', '3', '4', '5', '6', '7', '8', '9']} now={5} clock="Top 6th" players={[['Guerrero Jr.', '2-3, HR'], ['Judge', '1-3, 2B']]} teams={[
  { name: 'TOR', logo: espn('mlb', 'tor'), lines: [0, 2, 0, 1, 0, 0, 0, 0, 0] },
  { name: 'NYY', logo: espn('mlb', 'nyy'), lines: [1, 0, 0, 0, 0, 0, 0, 0, 0], behind: true },
]} />;

const MOCKS = [
  ['Live', 'NHL, with shots on goal', LiveNHL, 'Everything fake'],
  ['Live', 'NBA', LiveNBA, ''],
  ['Live', 'MLB', LiveMLB, ''],
  ['Final', 'G, when the same game ends', PeriodsStars, ''],
  ['A', 'Scores where the odds were', Slots, ''],
  ['B', 'Same, winner in team colour', SlotsColor, ''],
  ['C', 'Two lines, like a box score', Lines, ''],
  ['D', 'Score by period', Periods, 'Needs period scores'],
  ['E', 'Top players under the score', Stars, 'Needs player stats'],
  ['F', 'Your bet under the score', MyBet, 'Only on games you bet'],
];

export default function FinalMock() {
  return (
    <div className="fm-page">
      <style>{CSS}</style>
      <h2>Final score card</h2>
      <p className="fm-label"><b>Today</b> An upcoming game, for comparison</p>
      <Upcoming />
      {MOCKS.map(([id, name, Card, note]) => (
        <section key={id + name}>
          <p className="fm-label"><b>{id}</b> {name}{note && <em>{note}</em>}</p>
          <Card />
        </section>
      ))}
    </div>
  );
}

const CSS = `
html, body, #root { overflow: auto !important; height: auto !important; }
.fm-page { max-width: 716px; margin: 0 auto; padding: 20px 16px 60px; color: var(--text, #17181b); }
.fm-page h2 { margin: 0 0 6px; font-family: var(--fl-display); font-size: 30px; font-weight: 800; text-transform: uppercase; }
.fm-label { display: flex; align-items: center; gap: 8px; margin: 22px 0 8px; color: var(--text-muted, #5d6570); font-size: 13px; }
.fm-label b { color: var(--text, #17181b); font-size: 14px; }
.fm-label em { margin-left: auto; font-style: normal; font-size: 12px; }
.fm-card { padding: 14px; border: 1px solid var(--border, #e2e7ed); border-radius: 14px; background: #fff; box-shadow: 0 1px 4px rgba(0,0,0,0.06); }
.fm-head { display: flex; align-items: center; justify-content: space-between; padding: 0 26px 12px; }
.fm-when { font-family: var(--fl-display); font-size: 22px; font-weight: 700; }
.fm-slots { display: grid; grid-template-columns: 1fr 1fr; gap: 6px; padding-top: 10px; border-top: 1px solid var(--border, #e2e7ed); }
.fm-slot { display: flex; flex-direction: column; align-items: center; padding: 6px; border: 1px solid var(--border, #e2e7ed); border-radius: 8px; background: #f4f4f4; }
.fm-slot small { color: var(--text-muted, #5d6570); font-size: 11px; font-weight: 700; }
.fm-slot b { font-family: var(--fl-display); font-size: 20px; font-weight: 800; line-height: 1.2; }
.fm-slot b.big { font-size: 30px; line-height: 1.05; }
.fm-slot.win { background: #17181b; border-color: #17181b; color: #fff; }
.fm-slot.win small { color: rgba(255,255,255,0.7); }
.fm-page .muted { color: #9aa0a8; }
.fm-lines { display: flex; flex-direction: column; gap: 4px; }
.fm-line { display: flex; align-items: center; gap: 12px; padding: 5px 12px; border-left: 4px solid var(--c); border-radius: 4px; }
.fm-line b { flex: 1; font-family: var(--fl-display); font-size: 22px; font-weight: 700; }
.fm-line strong { font-family: var(--fl-display); font-size: 32px; font-weight: 800; line-height: 1; }
.fm-line.lose b, .fm-line.lose strong { color: #9aa0a8; }
.fm-foot { padding: 4px 0 0 16px; color: var(--text-muted, #5d6570); font-size: 12px; font-weight: 600; }
.fm-tr { display: grid; grid-template-columns: 1fr repeat(3, 44px) 56px; align-items: center; padding: 4px 8px; font-family: var(--fl-display); }
.fm-tr + .fm-tr { border-top: 1px solid var(--border, #e2e7ed); }
.fm-tr span { display: flex; align-items: center; gap: 10px; font-size: 20px; }
.fm-tr i { font-style: normal; font-size: 18px; text-align: center; color: var(--text-muted, #5d6570); }
.fm-tr strong { font-size: 30px; font-weight: 800; line-height: 1.1; text-align: center; }
.fm-th { font-size: 13px; font-weight: 700; text-transform: uppercase; }
.fm-th span { font-size: 15px; font-weight: 800; }
.fm-th i:last-child { color: var(--text, #17181b); font-weight: 800; }
.fm-tr.lose strong, .fm-tr.lose b { color: #9aa0a8; }
.fm-score { display: flex; align-items: center; gap: 20px; font-family: var(--fl-display); font-size: 40px; font-weight: 800; line-height: 1; }
.fm-score small { color: var(--text-muted, #5d6570); font-family: inherit; font-size: 14px; font-weight: 700; letter-spacing: 0.03em; }
.fm-stars { display: flex; justify-content: space-around; gap: 8px; padding-top: 10px; border-top: 1px solid var(--border, #e2e7ed); font-size: 13px; color: var(--text-muted, #5d6570); }
.fm-stars b { color: var(--text, #17181b); }
.fm-stars-under { margin-top: 4px; }
.fm-live { border-color: #ef4444; }
.fm-now { display: flex; align-items: center; justify-content: space-between; padding: 6px 26px 14px; border-bottom: 1px solid var(--border, #e2e7ed); }
.fm-now-team { display: flex; align-items: center; gap: 32px; flex: 1; }
.fm-now-team.home { justify-content: flex-end; }
.fm-now-team img { width: 44px; height: 44px; object-fit: contain; }
.fm-now-team small { color: var(--text-muted, #5d6570); font-size: 10px; font-weight: 700; }
.fm-now-score { display: flex; align-items: center; gap: 36px; font-family: var(--fl-display); }
.fm-now-score strong { font-size: 40px; font-weight: 800; line-height: 1; }
.fm-now-clock { display: flex; flex-direction: column; align-items: center; color: #ef4444; font-size: 15px; line-height: 1.3; text-transform: uppercase; }
.fm-now-clock b { font-weight: 700; }
.fm-now-clock u { width: 8px; height: 8px; margin-bottom: 3px; border-radius: 50%; background: #ef4444; }
.fm-tr i.now { color: #ef4444; font-weight: 800; }
.fm-th i:last-child.now { color: #ef4444; }
.fm-mybet { display: flex; justify-content: space-between; align-items: center; padding: 10px 12px 0; border-top: 1px solid var(--border, #e2e7ed); font-size: 13px; color: var(--text-muted, #5d6570); }
.fm-mybet b { color: var(--win, #22c55e); font-family: var(--fl-display); font-size: 24px; font-weight: 800; line-height: 1; }
@media (max-width: 480px) { .fm-head { padding: 0 8px 10px; } .fm-when { font-size: 18px; } .fm-score { gap: 12px; font-size: 32px; } .fm-tr { grid-template-columns: 1fr repeat(3, 30px) 44px; } }
`;
